// src/hooks/useAuth.ts
import { useState, useEffect } from "react";
import { apiClient } from "../api/apiClient";

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const login = async () => {
            const success = await apiClient.authenticate();
            setIsAuthenticated(success);
            setHasError(!success);
        };

        login();
    }, []);

    return { isAuthenticated, hasError };
};
